<template>
    <div class="totast-tip" :style="style">
        <p>{{msg}}</p>
    </div>
</template>

<script>
export default {
    data() {
        return {
            msg: '',
            style: {},
        };
    },
};
</script>
<style lang="scss" scoped>
@keyframes totast-fadeIn {
    0% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
}
.totast-tip {
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    overflow: hidden;
    z-index: 99999;
    padding: 10px 20px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.7);
    box-shadow: 0 5px 10px rgba(43, 45, 68, 0.76);
    color: #ffffff;
    display: inline-block;
    box-sizing: border-box;
    font-size: 26px;
    animation: totast-fadeIn 0.5s ease-in;
}
</style>
